export const frontmatter = {
    "title": "Frequently Asked Questions",
    "description": "Answers to the most common questions about OnnIA.",
    "sidebar_label": "FAQs",
    "sidebar_group": "reference",
    "sidebar_order": 2,
    "toc": false,
    "hide_title": true
}

export const toc = [
    {
        "depth": 2,
        "id": "getting-started",
        "value": "Getting Started"
    },
    {
        "depth": 2,
        "id": "channels",
        "value": "Channels"
    },
    {
        "depth": 2,
        "id": "agents-and-artificial-intelligence",
        "value": "Agents and Artificial Intelligence"
    },
    {
        "depth": 2,
        "id": "data-and-security",
        "value": "Data and Security"
    }
]